import { createAction, props } from '@ngrx/store';
import { Person } from '../../data/persons/person.model';
import { Organization } from '../../data/providers/organization.model';
import { PractitionerProvider } from '../../data/providers/practitioner-provider.model';

export enum UserFhirActions {
  UserPersonFetched = '[User/Fhir] User Person fetched',
  UserOrganizationFetched = '[User/Fhir] User Organization fetched',
  UserPractitionerProvidersFetched = '[User/Fhir] User Practitioner Providers fetched',
  UserOrganizationProvidersFetched = '[User/Fhir] User Organization Providers fetched',
}

export const userPersonFetched = createAction(
  UserFhirActions.UserPersonFetched,
  props<{
    userPerson: Person;
  }>(),
);

export const userOrganizationFetched = createAction(
  UserFhirActions.UserOrganizationFetched,
  props<{
    userOrganization: Organization;
  }>(),
);

export const userPractitionerProvidersFetched = createAction(
  UserFhirActions.UserPractitionerProvidersFetched,
  props<{
    userPractitionerProviders: PractitionerProvider[];
  }>(),
);

export const userOrganizationProvidersFetched = createAction(
  UserFhirActions.UserOrganizationProvidersFetched,
  props<{
    userOrganizationProviders: Organization[];
  }>(),
);
